import DefaultErrorPage from 'next/error'

import { IS_DEV } from '@/constants/environment'
import { useWebViewMode } from '@/hooks/useWebViewMode'

type OnlyWebViewProps = {
  children: React.ReactNode
  statusCode?: number
}

export const OnlyWebView = ({
  children,
  statusCode = 404,
}: OnlyWebViewProps) => {
  const isWebView = useWebViewMode({})

  return isWebView || IS_DEV ? (
    <>{children}</>
  ) : isWebView === undefined ? (
    <></>
  ) : (
    <DefaultErrorPage statusCode={statusCode} />
  )
}
